import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/pro-regular-svg-icons";
import {
  CfcReviewSubtitle,
  CfcReviewInfoGrid,
  CfcReviewInfoLabel,
  CfcReviewInfoValue,
  CfcReviewLinks,
  CfcReviewLink,
} from "./CfcStepReview.styles";
import { CfcPatientData } from "./types";

const EMPTY_FIELD_VALUE = "-";

const REVIEW_FIELDS: Array<{
  label: string;
  key: "firstName" | "lastName" | "dateOfBirth";
}> = [
  { label: "First name", key: "firstName" },
  { label: "Last name", key: "lastName" },
  { label: "Date of birth", key: "dateOfBirth" },
];

interface CfcStepReviewProps {
  patientData: CfcPatientData;
  onReviewReport: () => void;
}

export const CfcStepReview = ({
  patientData,
  onReviewReport,
}: CfcStepReviewProps): React.ReactElement => {
  const canReviewReport = Boolean(patientData.aneuploidyReportId);

  return (
    <>
      <CfcReviewSubtitle>
        Information for this patient has been pre-filled from the prior Unity
        Aneuploidy Screen (cfDNA) order.
      </CfcReviewSubtitle>
      <CfcReviewInfoGrid>
        {REVIEW_FIELDS.map(({ label, key }) => {
          const value = String(patientData[key] ?? "").trim();
          return (
            <React.Fragment key={key}>
              <CfcReviewInfoLabel>{label}</CfcReviewInfoLabel>
              <CfcReviewInfoValue>
                {value || EMPTY_FIELD_VALUE}
              </CfcReviewInfoValue>
            </React.Fragment>
          );
        })}
      </CfcReviewInfoGrid>
      {canReviewReport && (
        <CfcReviewLinks aria-label="Aneuploidy review document">
          <CfcReviewLink type="button" onClick={onReviewReport}>
            <FontAwesomeIcon icon={faEye} />
            Review Aneuploidy test report
          </CfcReviewLink>
        </CfcReviewLinks>
      )}
    </>
  );
};
